module.exports = __webpack_public_path__ + "img/2.14eb8e21.webp";